import React from "react"
import PropTypes from "prop-types"
import { Card, Typography, Flex } from "antd"
import styles from "../../index.module.css"

const { Title, Text } = Typography

export const WaiverDetails = ({ title, date, location, calendarIcon, addressIcon }) => {
  return (
    <Card className={styles.detailsCard}>
      <Title level={4} className={styles.tripTitle}>
        {title}
      </Title>
      <Flex align="center" gap={12} className="mt-s"> 
        <Flex align="center" style={{ flexShrink: 0 }}>
          <img src={calendarIcon} className={styles.icon} alt="Calendar" />
          <Text className={styles.detailText} style={{ whiteSpace: "nowrap" }}>{date}</Text>
        </Flex>
        <Flex align="center" style={{ minWidth: 0 }}>
          <img src={addressIcon} className={styles.icon} alt="Address" style={{ flexShrink: 0 }} />
          <Text className={styles.detailText} ellipsis={{ tooltip: location }}>{location}</Text>
        </Flex>
      </Flex>
    </Card>
  )
}

WaiverDetails.propTypes = {
  title: PropTypes.string,
  date: PropTypes.string,
  location: PropTypes.string,
  calendarIcon: PropTypes.string.isRequired,
  addressIcon: PropTypes.string.isRequired
}
